import {
  completePresignedFileUpload,
  initPresignedFileUpload,
} from "../apis/public";

const DEFAULT_CONTENT_TYPE = "application/octet-stream";

export const uploadHowToUseFile = async (file, secondType) => {
  if (!file || !secondType) {
    throw new Error("Missing file or resource type");
  }

  const requestedContentType = file.type || DEFAULT_CONTENT_TYPE;
  const initResult = await initPresignedFileUpload({
    fileName: file.name,
    fileType: secondType,
    fileSize: file.size,
    contentType: requestedContentType,
  });
  const upload = initResult?.data;

  if (!upload?.fileUuid) {
    throw new Error("Invalid presigned upload response");
  }
  if (upload.uploadMode !== "SINGLE" || !upload.presignedUrl) {
    throw new Error("How-to-use files do not support multipart upload");
  }

  const putResponse = await fetch(upload.presignedUrl, {
    method: "PUT",
    headers: {
      "Content-Type": upload.contentType || requestedContentType,
    },
    body: file,
  });

  if (!putResponse.ok) {
    throw new Error(`File upload failed: HTTP ${putResponse.status}`);
  }

  const completeResult = await completePresignedFileUpload({
    fileUuid: upload.fileUuid,
  });
  if (completeResult?.data !== true) {
    throw new Error("Failed to complete file upload");
  }

  return upload.fileUuid;
};
